/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type ChallengeNameType = (typeof ChallengeNameType)[keyof typeof ChallengeNameType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeNameType = {
  ADMIN_NO_SRP_AUTH: 'ADMIN_NO_SRP_AUTH',
  CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
  DEVICE_PASSWORD_VERIFIER: 'DEVICE_PASSWORD_VERIFIER',
  DEVICE_SRP_AUTH: 'DEVICE_SRP_AUTH',
  EMAIL_OTP: 'EMAIL_OTP',
  MFA_SETUP: 'MFA_SETUP',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  PASSWORD: 'PASSWORD',
  PASSWORD_SRP: 'PASSWORD_SRP',
  PASSWORD_VERIFIER: 'PASSWORD_VERIFIER',
  SELECT_CHALLENGE: 'SELECT_CHALLENGE',
  SELECT_MFA_TYPE: 'SELECT_MFA_TYPE',
  SMS_MFA: 'SMS_MFA',
  SMS_OTP: 'SMS_OTP',
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  WEB_AUTHN: 'WEB_AUTHN',
} as const
